import type { HTMLAttributes } from "react";

export interface LoadingOverlayProps extends HTMLAttributes<HTMLDivElement> {
  progress?: number;
  message?: string;
}

export function LoadingOverlay({
  progress,
  message = "Chargement...",
  ...props
}: LoadingOverlayProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-bg/50" {...props}>
      <div className="flex w-full max-w-sm flex-col items-center space-y-4 rounded-md bg-surface p-8 text-center shadow-lg">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-accent border-t-transparent" />
        {typeof progress === "number" && (
          <>
            <progress value={progress} max={100} className="block w-full" />
            <p className="text-sm text-muted">{progress}%</p>
          </>
        )}
        {message && <p className="text-muted">{message}</p>}
      </div>
    </div>
  );
}

export default LoadingOverlay;
